export default __webpack_public_path__ + "static/media/B_lopetus6.e88de0b9.mp3";